import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { InspectionStatus } from '../../utilities/enums';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { InspectionList, InspectionListCollection } from './inspectionList.types';

const useSelectedWorkPackageInspections = (workPackageId: number) => {
  const getInspectionQuery = useCallback(
    (collection: InspectionListCollection) =>
      collection?.find({
        selector: {
          $and: [
            { workPackageId },
            { assetInspectionStatusId: { $ne: InspectionStatus.COMPLETED } },
          ],
        },
      }),
    [workPackageId],
  );

  const { result: inspectionsUnderWorkPackage } = useRxData<InspectionList>(
    RxdbCollectionName.INSPECTION_LIST,
    getInspectionQuery,
    {
      json: true,
    },
  );

  return { inspectionsUnderWorkPackage };
};

export default useSelectedWorkPackageInspections;
